import React from 'react';
import { format, parseISO } from 'date-fns';
import { es } from 'date-fns/locale';

interface DeliveryDate {
  baseDate: string;
  shipping: string;
  delivery: string;
  deliverySlots: Array<{
    from: string;
    to: string;
    label: string;
  }>;
}

interface DeliveryDateSelectorProps {
  dates: DeliveryDate[];
  selectedIndex: number;
  onSelectDate: (index: number) => void;
}

const DeliveryDateSelector: React.FC<DeliveryDateSelectorProps> = ({ 
  dates, 
  selectedIndex, 
  onSelectDate 
}) => {
  const formatDate = (dateString: string) => {
    const date = parseISO(dateString);
    return format(date, "EEEE, d 'de' MMMM", { locale: es });
  };
  
  return (
    <div className="flex overflow-x-auto gap-3 pb-2 -mx-1 px-1">
      {dates.map((date, index) => (
        <button
          key={date.delivery}
          onClick={() => onSelectDate(index)}
          className={`flex-shrink-0 px-4 py-3 rounded-lg border-2 transition-all ${
            selectedIndex === index 
              ? 'border-blue-500 bg-blue-50' 
              : 'border-gray-200 hover:border-gray-300'
          }`}
        >
          <div className={`text-sm font-medium ${
            selectedIndex === index ? 'text-blue-700' : 'text-gray-500'
          }`}>
            {formatDate(date.delivery)}
          </div>
        </button>
      ))}
    </div>
  );
};

export default DeliveryDateSelector;